export enum SupportRequestStatus {
  new = 'new',
  resolved = 'resolved',
}

export interface SupportRequest {
  _id: string;
  rideId: string;
  userId: string;
  userName: string;
  userType: 'driver' | 'customer';
  message: string;
  status: SupportRequestStatus;
  createdAt: Date;
  updatedAt: Date;
  ride?: {
    pickupAddress: string;
    destinationAddress: string;
    status: string;
  };
}
